export default __webpack_public_path__ + "static/Tom.DaleBoardOfDirCHAIRSouthWest_social-05b823ac1233308139cc8454f1c22c10.jpg";